const Address = require('./Address.jsx');
const ContactMeta = require('./ContactMeta.jsx');
const Item = require('./Item.jsx');
const ItemContainer = require('./ItemContainer.jsx');
const LineItemCell = require('./LineItemCell.jsx');
const LineItems = require('./LineItems.jsx');
const Meta = require('./Meta.jsx');
const Name = require('../utility/Name.jsx');
const Signature = require('./Signature.jsx');
const Token = require('../utility/Token.jsx');
const Totals = require('./Totals.jsx');
const Utilities = require('../utility/Utilities.jsx');

const Blocks = {
    get: (group, data) => [
        {
            id: 'consignmentSeparator',
            dataType: 'separator', 
            display: 'Consignment', 
            group
        },
        {
            id: Name.Block.Client.ContactMeta,
            component: ContactMeta.Component,
            config: {
                Block: ContactMeta.TypeConfig.panel.block(),
                Style: ContactMeta.TypeConfig.panel.style(),
                Description: ContactMeta.TypeConfig.panel.description(),
                Label: ContactMeta.TypeConfig.panel.label(),
                Value: ContactMeta.TypeConfig.panel.value()
            },
            display: 'Contact Meta',
            group,
            image: ''
        },
        {
            id: Name.Block.Consignment.Meta,
            component: Meta.V2.Component,
            config: {
                Block: Meta.V2.TypeConfig.panel.block(),
                Style: Meta.V2.TypeConfig.panel.style(),
                Description: Meta.V2.TypeConfig.panel.description(),
                Label: Meta.V2.TypeConfig.panel.label(),
                Value: Meta.V2.TypeConfig.panel.value()
            },
            display: 'Consignment Meta',
            group,
            image: ''
        },
        {
            id: Name.Block.Consignment.Terms,
            blockType: Name.Block.Consignment.Meta,
            component: Meta.V2.Component,
            config: {
                Block: Meta.V2.TypeConfig.panel.block(),
                Style: Meta.V2.TypeConfig.panel.style(),
                Description: Meta.V2.TypeConfig.panel.description(),
                Label: Meta.V2.TypeConfig.panel.label(),
                Value: Meta.V2.TypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Terms}("before":"","after":"")}`, token: Token.Terms }))
            },
            display: 'Consignment Terms',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.List,
            component: LineItems.Component,
            config: {
                Block: LineItems.TypeConfig.panel.block(),
                Style: LineItems.TypeConfig.panel.style(),
                Visibility: LineItems.TypeConfig.panel.visibility(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: LineItemCell.Container.TypeConfig.defaultDesign(data) }
                ]
            },
            display: 'Line Items',
            group,
            image: ''
        },
        {
            id: Name.Block.Consignment.Totals,
            component: Totals.V2.Component,
            config: {
                Block: Totals.V2.TypeConfig.panel.block(),
                Style: Totals.V2.TypeConfig.panel.style(),
                Description: Totals.V2.TypeConfig.panel.description(),
                Label: Totals.V2.TypeConfig.panel.label(data),
                Value: Totals.V2.TypeConfig.panel.value(data),
                Visibility: Totals.V2.TypeConfig.panel.visibility()
            },
            display: 'Totals',
            group,
            image: ''
        },
        {
            id: Name.Block.Signature,
            component: Signature.V2.Component,
            config: {
                Block: Signature.V2.TypeConfig.panel.block(),
                Style: Signature.V2.TypeConfig.panel.style(),
                Description: Signature.V2.TypeConfig.panel.description(),
                Label: Signature.V2.TypeConfig.panel.label(),
                Value: Signature.V2.TypeConfig.panel.value()
            },
            display: 'Signature',
            group,
            image: ''
        },
    ],
    content: {
        [Name.Block.Inventory.List]: LineItemCell.Container.Blocks
    },
    tokens: (id, data) => {
        switch (id) {
            case Name.Block.Client.ContactMeta:
                return ContactMeta.Tokens();
            case Name.Block.Consignment.Meta:
                return Meta.V2.Tokens();
            case Name.Block.Consignment.Totals:
                return Totals.V2.Tokens(data);
            case Name.Block.Inventory.Meta:
                return LineItemCell.Meta.Tokens(data);
            case Name.Block.Signature:
                return Signature.V2.Tokens();
        //     case Name.Block.PaymentCredit.Amount:
        //     case Name.Block.PaymentCredit.Date:
        //     case Name.Block.PaymentCredit.Method:
        //         return PaymentCreditCell.Meta.Tokens(data);
        //     case Name.Block.Number:
        //         return Meta.V2.Number.Tokens(Name.Config.Invoice);
        //     case Name.Block.Total.Balance:
        //         return Totals.BalanceV2.Tokens(data);
        //     case Name.Block.Total.Discount:
        //         return Totals.DiscountV2.Tokens(data);
        //     case Name.Block.Total.GrandTotal:
        //         return Totals.GrandTotalV2.Tokens(data);
        //     case Name.Block.Total.Paid:
        //         return Totals.PaidV2.Tokens(data);
        //     case Name.Block.Total.PromoCodes:
        //         return Totals.PromoCodesV2.Tokens(data);
        //     case Name.Block.Total.Refunded:
        //         return Totals.RefundedV2.Tokens(data);
        //     case Name.Block.Total.Shipping:
        //         return Totals.ShippingV2.Tokens(data);
        //     case Name.Block.Total.Subtotal:
        //         return Totals.SubtotalV2.Tokens(data);
        }
    },

    legacy: [
        { display: 'Consignment Data Blocks', type: 'header' },
        {
            id: 'title',
            component: Meta.Title.Component,
            config: {
                Block: Meta.Title.TypeConfig.panel.block(),
                Style: Meta.Title.TypeConfig.panel.style()
            },
            display: 'Title',
            image: ''
        },
        {
            id: 'termDate',
            component: Meta.TermDate.Component,
            config: {
                Block: Meta.TermDate.TypeConfig.panel.block(),
                Style: Meta.TermDate.TypeConfig.panel.style()
            },
            display: 'Term Date',
            image: ''
        },
        {
            id: 'address',
            component: Address.Component,
            config: {
                Block: Address.TypeConfig.panel.block(),
                Includes: Address.TypeConfig.panel.includes(),
                Style: Address.TypeConfig.panel.style()
            },
            display: 'Consigner Address',
            image: ''
        },
        {
            id: 'terms',
            component: Meta.Terms.Component,
            config: {
                Block: Meta.Terms.TypeConfig.panel.block(),
                Style: Meta.Terms.TypeConfig.panel.style()
            },
            display: 'Terms',
            image: ''
        },
        {
            id: 'signature',
            component: Signature.Component,
            config: {
                Block: Signature.TypeConfig.panel.block(),
                Includes: Signature.TypeConfig.panel.includes(),
                Style: Signature.TypeConfig.panel.style()
            },
            display: 'Signature',
            image: ''
        },
        {
            id: 'totals',
            component: Totals.Component,
            config: {
                Block: Totals.TypeConfig.panel.block(),
                Includes: Totals.TypeConfig.panel.includes(),
                Style: Totals.TypeConfig.panel.style(),
                Format: Totals.TypeConfig.panel.format()
            },
            display: 'Totals',
            image: ''
        },
        { display: 'Item Data Blocks', type: 'header' },
        {
            id: 'itemContainer',
            component: ItemContainer.List,
            config: {
                Block: ItemContainer.TypeConfig.panel.block(),
                Columns: ItemContainer.TypeConfig.panel.columns(),
                Style: ItemContainer.TypeConfig.panel.style()
            },
            display: 'Item Container (required)',
            image: '',
            type: 'container'
        },
        {
            id: 'itemImage',
            component: Item.Image.Component,
            config: {
                Block: Item.Image.TypeConfig.panel.block(),
                Visibility: Item.Image.TypeConfig.panel.visibility(),
                Style: Item.Image.TypeConfig.panel.style()
            },
            display: 'Image',
            image: ''
        },
        {
            id: 'itemArtist',
            component: Item.Artist.Component,
            config: {
                Block: Item.Artist.TypeConfig.panel.block(),
                Style: Item.Artist.TypeConfig.panel.style()
            },
            display: 'Artist',
            image: ''
        },
        {
            id: 'itemTitle',
            component: Item.Title.Component,
            config: {
                Block: Item.Title.TypeConfig.panel.block(),
                Includes: Item.Title.TypeConfig.panel.includes({}),
                Style: Item.Title.TypeConfig.panel.style()
            },
            display: 'Title',
            image: ''
        },
        {
            id: 'itemEdition',
            component: Item.Edition.Component,
            config: {
                Block: Item.Edition.TypeConfig.panel.block(),
                Visibility: Item.Edition.TypeConfig.panel.visibility(),
                Style: Item.Edition.TypeConfig.panel.style(),
                Format: Item.Edition.TypeConfig.panel.format()
            },
            display: 'Edition',
            image: ''
        },
        {
            id: 'itemMedium',
            component: Item.Medium.Component,
            config: {
                Block: Item.Medium.TypeConfig.panel.block(),
                Visibility: Item.Medium.TypeConfig.panel.visibility(),
                Style: Item.Medium.TypeConfig.panel.style()
            },
            display: 'Medium',
            image: ''
        },
        {
            id: 'itemDimensions',
            component: Item.Dimensions.Component,
            config: {
                Block: Item.Dimensions.TypeConfig.panel.block(),
                Visibility: Item.Dimensions.TypeConfig.panel.visibility(),
                Style: Item.Dimensions.TypeConfig.panel.style()
            },
            display: 'Dimensions',
            image: ''
        },
        {
            id: 'itemNumber',
            component: Item.Number.Component,
            config: {
                Block: Item.Number.TypeConfig.panel.block(),
                Visibility: Item.Number.TypeConfig.panel.visibility(),
                Style: Item.Number.TypeConfig.panel.style()
            },
            display: 'Inventory Number',
            image: ''
        },
        {
            id: 'itemSKU',
            component: Item.SKU.Component,
            config: {
                Block: Item.SKU.TypeConfig.panel.block(),
                Visibility: Item.SKU.TypeConfig.panel.visibility(),
                Style: Item.SKU.TypeConfig.panel.style()
            },
            display: 'SKU',
            image: ''
        },
        {
            id: 'itemLocation',
            component: Item.Location.Component,
            config: {
                Block: Item.Location.TypeConfig.panel.block(),
                Visibility: Item.Location.TypeConfig.panel.visibility(),
                Style: Item.Location.TypeConfig.panel.style()
            },
            display: 'Location',
            image: ''
        },
        {
            id: 'itemAcquisitionDate',
            component: Item.AcquisitionDate.Component,
            config: {
                Block: Item.AcquisitionDate.TypeConfig.panel.block(),
                Visibility: Item.AcquisitionDate.TypeConfig.panel.visibility(),
                Style: Item.AcquisitionDate.TypeConfig.panel.style()
            },
            display: 'Acquisition Date',
            image: ''
        },
        {
            id: 'itemPrice',
            component: Item.Price.Component,
            config: {
                Block: Item.Price.TypeConfig.panel.block(),
                Visibility: Item.Price.TypeConfig.panel.visibility(),
                Style: Item.Price.TypeConfig.panel.style(),
                Format: Item.Price.TypeConfig.panel.format()
            },
            display: 'Price',
            image: ''
        },
        {
            id: 'itemConsignmentCost',
            component: Item.ConsignmentCost,
            config: {
                Block: Item.ConsignmentCost.TypeConfig.panel.block(),
                Visibility: Item.ConsignmentCost.TypeConfig.panel.visibility(),
                Style: Item.ConsignmentCost.TypeConfig.panel.style(),
                Format: Item.ConsignmentCost.TypeConfig.panel.format()
            },
            display: 'Consignment Cost',
            image: ''
        },
        {
            id: 'itemCustomMeta',
            component: Item.CustomMeta.Component,
            config: {
                Meta: Item.CustomMeta.TypeConfig.panel.meta(),
                Includes: Item.CustomMeta.TypeConfig.panel.includes(),
                Style: Item.CustomMeta.TypeConfig.panel.style()
            },
            display: 'Customized Details',
            image: ''
        }
    ]
};

module.exports = {
    Blocks
};